import { moduleName } from '../constants';

export const SET_SCREEN_META = `${moduleName}/SET_SCREEN_META`;
export const setScreenMeta = meta => ({ type: SET_SCREEN_META, payload: meta });
